/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type EstimateWeb3MigrationQueryVariables = Types.Exact<{ [key: string]: never }>;

export type EstimateWeb3MigrationQuery = {
	__typename?: "Query";
	estimateWeb3Migration: {
		__typename?: "Web3MigrationEstimation";
		userJourney: string;
		amount: { __typename?: "CurrencyAmount"; value: string };
	};
};

export const EstimateWeb3MigrationDocument = gql`
	query estimateWeb3Migration {
		estimateWeb3Migration {
			amount {
				value
			}
			userJourney
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class EstimateWeb3MigrationGQLService extends Apollo.Query<
	EstimateWeb3MigrationQuery,
	EstimateWeb3MigrationQueryVariables
> {
	document = EstimateWeb3MigrationDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
